/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css } from 'aphrodite';

import { ContextualHelpList } from '../../components/form/ContextualHelpList/ContextualHelpList';
import {
  contextualHelpRoomInstructions,
  contextualHelpClosedCaptionSupported,
} from '../../components/form/ContextualHelpList/contextualHelpUtils';
import { Message } from '../../components/form/TaskMessages/messageTypes';
import { TaskMessages } from '../../components/form/TaskMessages/TaskMessages';
import { styles as taskStyles } from '../../components/form/styles';
import { ExitWindowButton } from '../../components/common/ExitWindowButton/ExitWindowButton';
import { useConsumerTheme, ConsumerAppConfigContext } from '../../hooks/useConsumerTheme';
import { Footer } from '../TasksPage/Footer/Footer';
import { getConfig } from '@utils/configs';

const generateStyles = (_appConfig: ConsumerAppConfigContext) => ({
  pageWrapper: {
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
  },
  ...taskStyles,
});

export namespace ParticipantRoomNotScheduledPage {
  export interface Props {}
}

export const ParticipantRoomNotScheduledPage: React.FC<ParticipantRoomNotScheduledPage.Props> = ({}) => {
  const { styles } = useConsumerTheme(generateStyles);

  const contextualHelps = [contextualHelpRoomInstructions];

  if (getConfig()?.enableZoomForBSR20240730) {
    contextualHelps.unshift(contextualHelpClosedCaptionSupported);
  }

  return (
    <div className={css(styles.pageWrapper)} data-it="ParticipantRoomNotScheduledPage">
      <div className={css(styles.defaultTemplate)}>
        <div>
          <TaskMessages messages={messages} />
          <ContextualHelpList contextualHelps={contextualHelps} />
        </div>
        <ExitWindowButton />
      </div>
      <Footer />
    </div>
  );
};

const messages: Message[] = [
  {
    display: `Your online notarization hasn't been scheduled yet.`,
    type: 'simple',
    headingType: 'primaryHeading',
  },
  {
    display: 'Calendar',
    type: 'image',
    image: 'calendar',
  },
  {
    display: `<p>But no need to worry, we'll reach out asking you to share your scheduling preferences soon.</p> 
     <p>If you have any questions, please contact your lender.</p>`,
    type: 'simple',
    headingType: 'secondaryHeading',
  },
];
